/**
 * @generated SignedSource<<1b418fef24a3af8d38967a4c8477d06b>>
 * @relayHash 57cbb0eac9d3c04af35bcbd22662d0c0
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/542.0.0-2026-01-14T22:13:51.780Z/SbRespCreatorsLayoutRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type SbRespCreatorsLayoutRefetchQuery$variables = {
  fetchUser: boolean;
  followSearchPages?: ReadonlyArray<string | null> | null;
  followSearchTypes?: ReadonlyArray<types | null> | null;
  isClient: boolean;
  rerankGuestId?: string | null;
  rerankUserId?: string | null;
  userId?: string | null;
};
export type SbRespCreatorsLayoutRefetchQuery$data = {
  readonly viewer: {
    readonly user?: {
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"SbRespCreatorsComponents_user" | "useSbSharedPageTracking_user">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"useSbSharedPageTracking_viewer">;
  };
};
export type SbRespCreatorsLayoutRefetchQuery = {
  response: SbRespCreatorsLayoutRefetchQuery$data;
  variables: SbRespCreatorsLayoutRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "followSearchPages"
},
v2 = {
  "defaultValue": [
    "SEARCH",
    "USER_PREFERENCE"
  ],
  "kind": "LocalArgument",
  "name": "followSearchTypes"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isClient"
},
v4 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "rerankGuestId"
},
v5 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "rerankUserId"
},
v6 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userId"
},
v7 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "pages",
    "variableName": "followSearchPages"
  },
  {
    "kind": "Variable",
    "name": "types",
    "variableName": "followSearchTypes"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SbRespCreatorsLayoutRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useSbSharedPageTracking_viewer"
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useSbSharedPageTracking_user"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SbRespCreatorsComponents_user"
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "SbRespCreatorsLayoutRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "guestId",
                    "variableName": "rerankGuestId"
                  },
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "rerankUserId"
                  }
                ],
                "kind": "ScalarField",
                "name": "isEligibleForRerank",
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isVerifiedTrade",
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TradeFirmType",
                    "kind": "LinkedField",
                    "name": "tradeFirm",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "kind": "LinkedField",
                        "name": "rewards",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ParentProgram",
                            "kind": "LinkedField",
                            "name": "currentProgram",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LoyaltyProgram",
                                "kind": "LinkedField",
                                "name": "programInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "code",
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "condition": "fetchUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v11/*: any*/),
                        "concreteType": "favoritesConnection",
                        "kind": "LinkedField",
                        "name": "favorites",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "favoritesEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Favorite",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayName",
                                    "storageKey": null
                                  },
                                  (v10/*: any*/),
                                  {
                                    "kind": "ClientExtension",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "__id",
                                        "storageKey": null
                                      }
                                    ]
                                  },
                                  (v9/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v11/*: any*/),
                        "filters": [],
                        "handle": "connection",
                        "key": "SharedSaveSearchContext_favorites",
                        "kind": "LinkedHandle",
                        "name": "favorites"
                      }
                    ]
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/542.0.0-2026-01-14T22:13:51.780Z/SbRespCreatorsLayoutRefetchQuery",
    "metadata": {},
    "name": "SbRespCreatorsLayoutRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "45ff9bdd3b34973d9441196d285b7a64";

export default node;
